<template>
  <div class="rm-screen">
    <div v-if="!user" class="rm-empty">{{ $t("no_data") }}</div>

    <template v-else>
      <div class="rm-month-nav">
        <button type="button" class="rm-icon-btn" :aria-label="$t('report_mobile.prev_month')" @click="stepMonth(-1)">
          <v-icon size="20" color="#1c1917">mdi-chevron-left</v-icon>
        </button>
        <div class="rm-month-nav__title" aria-live="polite">
          <span class="rm-month-nav__name">{{ monthTitle }}</span>
          <span v-if="monthHint" class="rm-muted rm-month-nav__hint">{{ monthHint }}</span>
        </div>
        <button type="button" class="rm-icon-btn" :aria-label="$t('report_mobile.month_next')" @click="stepMonth(1)">
          <v-icon size="20" color="#1c1917">mdi-chevron-right</v-icon>
        </button>
      </div>

      <div class="rm-stats rm-stats--pair">
        <div class="rm-stat rm-stat--inverse">
          <span class="rm-stat__label">{{ $t("orders") }}</span>
          <span class="rm-stat__value rm-num">{{ orders.length }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("spent_on_credits") }}</span>
          <span class="rm-stat__value rm-num">{{ money(creditsTotal) }}</span>
        </div>
      </div>

      <div v-if="loading" class="rm-empty">
        <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
      </div>
      <div v-else-if="failed" class="rm-empty">
        {{ $t("report_mobile.load_failed") }}
        <button type="button" class="rm-btn rm-btn--sm rm-emp-retry" @click="load">
          {{ $t("report_mobile.retry") }}
        </button>
      </div>
      <ul v-else-if="orders.length" class="rm-list rm-card">
        <li v-for="order in orders" :key="order.id" class="rm-day">
          <span class="rm-day__tile is-ordered">
            <span class="rm-day__num rm-num">{{ order.day }}</span>
            <span class="rm-day__weekday">{{ order.weekday }}</span>
          </span>
          <span class="rm-day__text">
            <span class="rm-day__meal">{{ order.items || "–" }}</span>
            <span class="rm-muted">{{ order.meta }}</span>
          </span>
        </li>
      </ul>
      <div v-else class="rm-empty">{{ $t("report_mobile.no_orders_month") }}</div>
    </template>
  </div>
</template>

<script>
import hasCreditUserMonth from "../../../shared/more/hasCreditUserMonth";

/**
 * Mobilni "Kreditni korisnik – narudžbe po mesecima": narudžbe izabranog meseca sa iznosom i potrošenim kreditom.
 * Korisnik (i firma) dolaze iz store-a (report/selectedEmployee), mesec iz kraja izabranog perioda.
 */
export default {
  name: "MoreMobileCreditUser",
  mixins: [hasCreditUserMonth],
  computed: {
    context() {
      return this.$store.state.report.selectedEmployee;
    },
    /** Isti oblik kao red izveštaja: { user_id, user_name } */
    user() {
      const context = this.context;
      return context && context.credit ? { user_id: context.id, user_name: context.fullName || context.name } : null;
    },
    companyId() {
      return this.context ? this.context.companyId : null;
    },
  },
};
</script>
